export default "__VITE_ASSET__A9kZGslc__"